<template>
  <div class="row bg-cat" :style="'margin: 0; color:#fff; min-height:100vh; padding: 30px 0 50px 0;'">
    <div class="container bgw">
      <div class="row">
        <div class="col-md-12">
          <h1 class="text-center">Контакты</h1>
          <div class="row">

            <div class="col-md-6">
              <img :src="map()" style="max-width:100%;" alt="">
            </div>

            <div class="col-md-6">
              <div class="col-md-12 text-left" v-for="pickup in state.pickups">
                <h3>{{ pickup.name }}</h3>
                <p>{{ pickup.descr }}</p>
              </div>
              <div class="col-md-12 text-left">
                <h3>Тел: {{ state.info.phone }}</h3>
                <div class="store" v-if="state.info.android">
                  <a :href="state.info.android"><img :src="state.config.url + 'images/googlePlay.png'" height="42px" alt="Загрузите в AppStore"></a>
                </div>
                <div class="social" v-if="state.info.instagram">
                  <a style="color:#fff;" target="_blank" :href="state.info.instagram">
                    <i class="fab fa-instagram"></i>
                  </a>
                </div>
                <div class="social" v-if="state.info.vk">
                  <a style="color:#fff;" target="_blank" :href="state.info.vk">
                    <i class="fab fa-vk"></i>
                  </a>
                </div>
                <div class="social" v-if="state.info.flamp">
                  <a style="color:#fff;" target="_blank" :href="state.info.flamp">
                    FL
                  </a>
                </div>
                <div class="store" v-if="state.info.ios">
                  <a :href="state.info.ios"><img :src="state.config.url + 'images/appStore.png'" height="42px" alt="Загрузите в AppStore"></a>
                </div>
              </div>
            </div>

            <div class="col-md-12 mt-5 text-left">
              <h2 class="text-left">Реквизиты компании</h2>
              <p class="mb-0">Название компании: ИП Репидо Н.В.</p>
              <p class="mb-0">ОГРНИП: 318703100058689 от 06.03.2018</p>
              <p class="mb-0">ИНН: 701715508731</p>
              <p class="mb-0">Р/счет: 40802810631000067810</p>
              <p class="mb-0">Банк: КРАСНОЯРСКОЕ ОТДЕЛЕНИЕ N 8646 ПАО СБЕРБАНК</p>
              <p class="mb-0">БИК: 040407627</p>
              <p>К/счет: 30101810800000000627</p>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import map from './../../assets/img/map.png'
  export default {
    computed: {
      state() {
        return this.$store.state
      }
    },
    methods: {
      map() {
        return map;
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Home/contact.vue